/**
 *
 * DeleteGroupPopup
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 11-Jan-2023
 */

import React from 'react';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessages from '../../modules/languageModule';
import PropTypes from 'prop-types';
import style from './DeleteStorePopup.scss';

const DeleteStorePopup = (props) => (
	<PortalModal
		className={style.container}
		title={formattedMessages.warning}
		subtitle={formattedMessages.subtitleDelete}
		subtitleValues={formattedMessages.deleteSubtitle}
		actions={{ handleClose: () => {} }}
		buttons={[
			{
				variant: 'outlined',
				onClick: props.actions.closeModal,
				contentText: formattedMessages.abortLabelButton,
			},
			{
				variant: 'contained',
				onClick: () => props.actions.deleteStore(props.payload),
				contentText: formattedMessages.confirmLabelButton,
				isLoading: props.isLoading,
			},
		]}
	/>
);

DeleteStorePopup.propTypes = {
	// Add here some propTypes
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

DeleteStorePopup.defaultProps = {
	// Add here some default propTypes values
	actions: {},
	isLoading: false,
};
export default DeleteStorePopup;
